import { Instance, types } from 'mobx-state-tree';

const Media = types
	.model('Media', {
		id: types.maybe(types.number),
		url: types.maybeNull(types.string),
		original_name: types.maybeNull(types.string),
		size: types.maybeNull(types.number),
	})
	.views((self) => ({
		get formatedSize() {
			if (self.size >= 1024 * 1024) {
				return `${(self.size / (1024 * 1024)).toFixed(1)} MB`;
			}
			if (self.size >= 1024) {
				return `${(self.size / 1024).toFixed(1)} KB`;
			}

			return `${self.size} B`;
		},
	}));

export default Media;

export interface IMediaModel extends Instance<typeof Media> {}
